import { toast } from 'react-toastify';
import { login } from '../../services/Auth';
import { LOGIN_SUCCESS, LOGIN_ERROR } from '../slices/authenticationSlice';

export const loginAction = (authData) => async (dispatch) => {
    const res = await login(authData);
    if (res?.statusCode === '200') {
        localStorage.setItem('userInfo', res?.token);
        localStorage.setItem('storeName', res?.storename);
        localStorage.setItem('userId', res?.user_id)
        localStorage.setItem('roleId', res?.roleid);
        localStorage.setItem('storeId', res?.storeid);
        window.location.reload();
    } else {
        return res;
    }
};
